import { createSelector } from '@reduxjs/toolkit'
import {
  getCurrentStoryId,
  getStories,
  getStory,
  getStoriesMeta,
} from '../../getters'

export const selectStories = createSelector([getStories], (stories) => stories)

export const selectStory = createSelector([getStory], (story) => story)

export const selectCurrentStoryId = createSelector(
  [getCurrentStoryId],
  (storyId) => storyId
)

export const selectCurrentStory = createSelector(
  [selectCurrentStoryId, selectStories],
  (currentStoryId, stories) => stories?.[currentStoryId] || undefined
)

export const selectStoriesMeta = createSelector(
  [getStoriesMeta],
  (storiesMeta) => storiesMeta
)
